import React from "react";
import "./landing.css";

export default function Ordering() {
  return (
    <section className="tfm-section tfm-section--paper" id="ordering">
      <div className="tfm-container">
        <div className="tfm-section-head">
          <p className="tfm-eyebrow">Ordering</p>
          <h2 className="tfm-h2" style={{ marginTop: "1.1rem" }}>
            Three ways to send us an order.
          </h2>
          <p className="tfm-lede">
            Use whichever fits your kitchen. Once the order is approved it goes
            straight to our delivery team, and you pay cash on delivery.
          </p>
        </div>

        <div className="tfm-channels">
          <article className="tfm-channel">
            <span className="tfm-channel__icon">
              <AppIcon />
            </span>
            <h3 className="tfm-channel__title">Mobile app</h3>
            <p className="tfm-channel__body">
              Build a pantry list you reorder in seconds, or start fresh each
              time. Works on Android and iOS, and our team will help you set it
              up.
            </p>
            <div className="tfm-stores">
              <a href="/" aria-label="Get it on Google Play">
                <img src="/images/gglplay.png" alt="Get it on Google Play" loading="lazy" />
              </a>
              <a href="/" aria-label="Download on the App Store">
                <img src="/images/appstore.png" alt="Download on the App Store" loading="lazy" />
              </a>
            </div>
          </article>

          <article className="tfm-channel">
            <span className="tfm-channel__icon">
              <MailIcon />
            </span>
            <h3 className="tfm-channel__title">Email</h3>
            <p className="tfm-channel__body">
              Send your list and our team will price it against this
              morning&rsquo;s market and come back to you.
            </p>
            <span className="tfm-channel__value">info@tripolifreshmarket.com</span>
            <a
              className="tfm-btn tfm-btn--line"
              href="mailto:info@tripolifreshmarket.com"
            >
              Email your order
            </a>
          </article>

          <article className="tfm-channel">
            <span className="tfm-channel__icon">
              <PhoneIcon />
            </span>
            <h3 className="tfm-channel__title">Phone</h3>
            <p className="tfm-channel__body">
              Call the ordering line and someone on the team will take it down
              with you.
            </p>
            <span className="tfm-channel__value">+961 71 144 332</span>
            <a className="tfm-btn tfm-btn--green" href="tel:+96171144332">
              Call to order
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}

function AppIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" aria-hidden="true">
      <path d="M12.71 16.29l-.15-.12a.76.76 0 00-.18-.09L12.2 16a1 1 0 00-.91.27 1.15 1.15 0 00-.21.33 1 1 0 001.3 1.31 1.46 1.46 0 00.33-.22 1 1 0 00.21-1.09 1 1 0 00-.21-.31zM16 2H8a3 3 0 00-3 3v14a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-3-3zm1 17a1 1 0 01-1 1H8a1 1 0 01-1-1V5a1 1 0 011-1h8a1 1 0 011 1z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" aria-hidden="true">
      <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6m-2 0l-8 5-8-5h16m0 12H4V8l8 5 8-5v10z" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" aria-hidden="true">
      <path d="M17.707 12.293a.999.999 0 00-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 000-1.414l-4-4a.999.999 0 00-1.414 0L3.581 5.005c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268s8.844 4.274 10.269 4.298h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 000-1.414l-4-4.001z" />
    </svg>
  );
}
